import { render } from "./EditTaskPage.vue?vue&type=template&id=45ee90eb&scoped=true"
import script from "./EditTaskPage.vue?vue&type=script&lang=js"
export * from "./EditTaskPage.vue?vue&type=script&lang=js"

import "./EditTaskPage.vue?vue&type=style&index=0&id=45ee90eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ee90eb"]])

export default __exports__